import { Trans, useTranslation } from 'react-i18next'
import { Link as DomLink } from 'react-router-dom'
import { ParcelType404Illustration } from '@dhl-ui/illustrations'
import { Link } from '@dhl-ui/components'

import { links } from '~/AppRoutes'
import { NotAvailablePage } from '~/modules/navigation/views/NotAvailablePage'

export const NotFoundPage = () => {
  const { t } = useTranslation()

  const linkToDashboard = <Link component={DomLink} key={0} href={links.dashboardLink()} title="go to dashboard" />

  return (
    <NotAvailablePage
      title={t('admin.navigation.notFound.title')}
      Image={ParcelType404Illustration}
      dataTest="route-not-found"
    >
      <Trans i18nKey="admin.navigation.notFound.description" components={{ linkToDashboard }} />
    </NotAvailablePage>
  )
}
